import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { BaseOperation } from 'media.operations/ops/base'

@Component({
  selector: 'media-operation-button',
  templateUrl: './mediaOperationButton.component.pug',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaOperationButtonComponent {
  @Input() operation: BaseOperation
  @Input() disabled = false
  @Output() activate = new EventEmitter<void>()
}
